<form #form="ngForm" class="h-full">
	<div class="gap-y-8 flex flex-col">
		<app-input
			name="title"
			label="Name"
			required
			placeholder="Title here"
			[submitted]="form.submitted"
			[(ngModel)]="document.title"
		>
		</app-input>
		<app-dropdown
			[autoSelectLabel]="true"
			[disabled]="this.mode === EditDocumentDrawerModeEnum.CREATE"
			[ngModel]="initialVersion"
			[submitted]="form.submitted"
			[itemGroups]="[{ items: versionList }]"
			name="versionHistory"
			label="Version History"
			required
			(ngModelChange)="onVersionSelected($event)"
		>
		</app-dropdown>

		<app-input-wrapper label="File Type">
			<matter-type-selector
				name="matterType"
				[disabled]="false"
				[matterTypes]="document.matterType"
				(matterTypesChange)="onMatterTypesUpdate($event)"
			></matter-type-selector>
		</app-input-wrapper>
		<!-- 
		<app-checkbox
			name="alwaysExists"
			[(ngModel)]="document.alwaysExists"
			label="Add To File By Default"
			type="clear"
		>
		</app-checkbox> -->

		<app-checkbox
			name="ignoreBusinessStylingSettings"
			[(ngModel)]="document.ignoreBusinessStylingSettings"
			label="Ignore Business Styling Settings"
			type="clear"
		>
		</app-checkbox>

		<app-dropdown
			[(ngModel)]="document.baseDocxReferenceId"
			[autoSelectLabel]="true"
			[itemGroups]="[{ items: baseDocxList }]"
			name="baseDocx"
			label="Document Letterhead & Footer"
		>
		</app-dropdown>
	</div>
</form>
